import {
  Line,
  mixins
} from 'vue-chartjs'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData'],
  data() {
      return {
          options: { //Chart.js options
              scales: {
                  yAxes: [{
                      ticks: {
                          beginAtZero: false,
                          callback: function(label, index, labels) {
                              if(label > 999999) {
                                return '$'+label/1000000+'M';
                              } else if (label < -999999) {
                                return '$'+label/1000000+'M';
                              } else {
                                return '$'+label/1000+'k';  
                              }
                        }
                      },
                      gridLines: {
                          display: true
                      }
                  }],
                  xAxes: [{
                      gridLines: {
                          display: false
                      }
                  }]
              },
              legend: {
                  display: true
              },
              tooltips: {
                mode: 'index',
                intersect: false,
                callbacks : {
                  label: function(tooltipItem, data) {
                    var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                    //return datasetLabel + ' : $' + ((parseFloat(tooltipItem.yLabel))/1000).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,')+"k";
                    return datasetLabel + ' : $' + (Math.round((parseFloat(tooltipItem.yLabel))/1000,0)).toLocaleString() + "k";
                  }
                }
                
            },
              responsive: true,
              maintainAspectRatio: false,
             
          }
      }
  },
  mounted() {
      this.renderChart(this.chartdata, this.options)
  }

}